import { useEffect } from "react";

export const useSeo = (title, description) => {
  useEffect(() => {
    if (title) document.title = `${title} | MI Futuhiyyah Doro`;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
  }, [title, description]);
};
